{
  "fr": {
    "courseDetail": {
      "headers": {
        "title": "Détails du cours"
      },
      "labels": {
        "course": "Formation en ligne",
        "webinar": "Webinaire en direct",
        "impulse": "fobizz Impuls",
        "workshop": "Atelier"
      },
      "headings": {
        "learningGoals": "Objectifs d'apprentissage",
        "lessons": "Contenus",
        "recommendations": "Ces sujets pourraient aussi t'intéresser",
        "feedbacks": "Avis"
      },
      "buttons": {
        "startNextLesson": "Commence la prochaine unité",
        "startImpulse": "Commence l'impuls",
        "enrollFree": "S'inscrire maintenant",
        "enrollFreeGroup": "S'inscrire maintenant",
        "enrollFreeSubscription": "S'inscrire maintenant",
        "enrollSubscription": "Souscrire à la Flatrate",
        "enrollInternationalSubscription": "Licence fobizz",
        "orderFreeFlatrate": "Tester la Flatrate",
        "getStarted": "S'inscrire maintenant",
        "downloadCertificate": "Télécharger le certificat",
        "showMore": "Voir plus...",
        "bookmark": "Enregistrer",
        "unbookmark": "Supprimer",
        "completeWebinar": "Terminer le webinaire"
      },
      "sidebar": {
        "content": "Contenus de la formation",
        "author": "Auteur·e",
        "feedback": "Avis",
        "certificate": "Certificat",
        "speaker": "Intervenant·e",
        "accessInfo": "Données d'accès",
        "recording": "Enregistrement",
        "documents": "Documents",
        "info": "Informations générales",
        "navLabel": "Navigation du cours"
      },
      "enrollment": {
        "expired": "Ton accès à cette formation a expiré",
        "expiredAt": "Ton accès à cette formation a expiré le {date}",
        "accessUntil": "Tu as encore accès à cette formation jusqu'au {date}.",
        "freeHint": "Cours gratuit",
        "closedHint": "Plus d'inscription possible",
        "vidisHint": "Avec ton compte {vidis}, tu ne peux pas réserver cette offre directement. Veuillez envoyer un e-mail à {emailLink}.",
        "paidHintFlatrate": "Avec un {flatrateLink}, tu as accès à tous les cours pendant un an à partir de {price}.",
        "paidHintCoupon": "Avec le code {couponLink}, tu peux tester tous les cours, IA et outils pendant un mois sans engagement."
      },
      "webinar": {
        "startsAt": "Les informations de participation pour le webinaire seront affichées ici peu avant.",
        "startsAtFuture": "Le webinaire a lieu le <strong>{date} de {start} à {end} {timezone}</strong>.",
        "startsAtPast": "Le webinaire a eu lieu le <strong>{date} de {start} à {end} {timezone}</strong>.",
        "startsAtNow": "Le webinaire a lieu en ce moment de <strong>{start} à {end} {timezone}</strong>.",
        "startsAtToday": "Le webinaire a lieu aujourd'hui de <strong>{start} à {end} {timezone}</strong>.",
        "startsAtTodayPast": "Le webinaire a eu lieu aujourd'hui de <strong>{start} à {end} {timezone}</strong>.",
        "recordingHint": "Il y aura un enregistrement de cet événement.",
        "noRecording": "Il n'y aura pas d'enregistrement de cet événement."
      },
      "accessInfo": {
        "recordingHintHtml": "Remarque : Les sous-titres de nos vidéos sont générés automatiquement. Il se peut que certains termes ne soient pas correctement restitués. Si tu as des retours sur les sous-titres, contacte-nous à <a href=\"mailto:support{'@'}fobizz.com\" target=\"_blank\">support{'@'}fobizz.com</a>",
        "recordingPending": "L'enregistrement est en cours de traitement. Dès qu'il sera disponible, il sera affiché ici.",
        "noRecording": "Il n'y a pas d'enregistrement pour ce webinaire."
      },
      "feedback": {
        "emptyHint": "Cette formation est nouvelle. Il n'y a pas encore d'avis - mais nous attendons avec impatience les premiers retours.",
        "carousel": {
          "previous": "Retour",
          "next": "Suivant"
        }
      },
      "feedbackNew": {
        "heading": "Conclusion et feedback",
        "complete": "Veuillez terminer toutes les leçons pour donner votre feedback. Merci !",
        "existing": "Vous avez déjà donné votre feedback. Merci beaucoup !",
        "downloadCertificate": "Télécharger le certificat",
        "form": {
          "rating": "Comment évalues-tu cette formation en général ?",
          "ratingLabels": {
            "1": "Terrible",
            "2": "Mauvais",
            "3": "Correct",
            "4": "Bien",
            "5": "Très bien"
          },
          "recommendationScore": "Quelle est la probabilité que tu recommandes fobizz ?",
          "recommendationLow": "Peu probable",
          "recommendationHigh": "Très probable",
          "continueUsing": "Souhaites-tu continuer à utiliser fobizz ?",
          "continueUsingTrue": "Oui",
          "continueUsingFalse": "Non",
          "publicComment": "Ton avis sur la formation",
          "publicCommentHelp": "512 caractères maximum",
          "authorName": "Attribution de l'avis",
          "authorNameHelp": "p. ex. Marie Muster, institutrice primaire de NRW",
          "personalComment": "Feedback personnel à l'auteur·e et à l'équipe fobizz",
          "personalCommentHelp": "512 caractères maximum",
          "requestedTopics": "Quels sujets souhaites-tu encore de fobizz ?",
          "requestedTopicsHelp": "512 caractères maximum",
          "submit": "Envoyer et accéder au certificat",
          "optional": "(facultatif)",
          "requiredHint": "Champ obligatoire",
          "errors": {
            "ratingRequired": "Veuillez choisir une évaluation.",
            "recommendationRequired": "Veuillez choisir une valeur entre 0 et 10.",
            "continueUsingRequired": "Veuillez choisir une option.",
            "maxLength": "512 caractères maximum autorisés."
          }
        }
      },
      "lesson": {
        "headers": {
          "courseContent": "Contenus de la formation"
        },
        "links": {
          "completeAndNext": "Terminé et suivant",
          "complete": "Terminé",
          "next": "Suivant",
          "previous": "Retour",
          "overview": "Retour à l'aperçu du cours"
        },
        "labels": {
          "complete": "terminé"
        },
        "paragraphs": {
          "notEnrolled": "Tu n'es pas encore inscrit·e à cette formation.",
          "notRegistered": "Connecte-toi pour t'inscrire à cette formation."
        },
        "blocks": {
          "download": "Télécharger",
          "noPreview": "Aucun aperçu disponible",
          "unsupported": "Ce contenu ne peut pas être affiché.",
          "videoFallback": "Ton navigateur ne supporte pas les vidéos intégrées."
        }
      },
      "recommendations": {
        "empty": "Il n'y a actuellement aucune recommandation.",
        "error": "Les recommandations n'ont pas pu être chargées."
      },
      "status": {
        "headings": {
          "thanks": "Merci pour ton retour !",
          "courseIncomplete": "Formation non terminée",
          "courseIncompleteWebinar": "Webinaire non terminé",
          "nextSteps": "Quelle est la suite ?",
          "noFeedback": "Pas encore donné de retour ?"
        },
        "paragraphs": {
          "certificate": "Vous trouverez votre certificat ici après avoir terminé.",
          "courseCompleted": "Vous avez terminé cette formation.",
          "courseCompletedWebinar": "Vous avez terminé ce webinaire.",
          "courseIncomplete": "Terminez toutes les leçons de la formation pour obtenir votre certificat.",
          "courseIncompleteWebinar": "Marquez le webinaire comme terminé pour obtenir votre certificat.",
          "downloadCertificate": "Téléchargez maintenant votre certificat.",
          "materialsHtml": "Consultez les <strong>matériels pédagogiques interactifs</strong> pour voir si vous trouvez quelque chose d'adapté.",
          "certificateNotReady": "Une fois la formation terminée, vous trouverez ici votre certificat.",
          "certificateNotReadyWebinar": "Une fois le webinaire terminé, vous trouverez ici votre certificat."
        },
        "links": {
          "downloadCertificate": "Télécharger le certificat",
          "gallery": "Découvrir le matériel",
          "feedback": "Évaluer la formation maintenant",
          "feedbackWebinar": "Évaluer le webinaire maintenant"
        }
      },
      "accordion": {
        "feedbackAndCertificate": "Feedback et certificat"
      },
      "format": {
        "title": {
          "b2bWorkshop": "Interne à l'école & pratique",
          "b2cWorkshop": "En direct & interactif",
          "webinar": "En direct & direct",
          "impulse": "Court & concis",
          "course": "Développement à son propre rythme"
        },
        "content": {
          "b2bWorkshop": "Les ateliers offrent des formations sur mesure directement dans votre école. Avec le corps enseignant, des sujets pratiques sont élaborés, adaptés aux besoins et défis spécifiques de votre établissement.",
          "b2cWorkshop": "Les ateliers sont des webinaires en direct avec un caractère d'atelier interactif. Vous travaillez ici avec d'autres enseignants sur des sujets pratiques et échangez en groupe. Parfait pour tous ceux qui souhaitent se connecter et apprendre les uns des autres.",
          "webinar": "Les webinaires en direct chez fobizz permettent un échange numérique avec des intervenants variés du monde éducatif. Des conférences et exercices variés suscitent de nouvelles impulsions, questions et discussions qui vont au-delà de l'échange avec les collègues en salle des profs. Par la suite, un enregistrement est souvent disponible pour ceux qui n'ont pas pu être présents en direct.",
          "impulse": "Formez-vous en seulement 30 minutes. Obtenez de brefs aperçus de nouveaux univers thématiques ou d'idées pédagogiques. Vous pouvez ainsi remplir un court créneau de la journée de manière flexible et spontanée avec une dose de savoir pratique - et cela en une seule vidéo ! Pour l'accompagnement en pratique, chaque impulsion est accompagnée d'un exercice et d'un matériel supplémentaire. Après chaque impulsion, vous recevez des recommandations pour approfondir votre savoir de manière autonome.",
          "course": "Obtenez des aperçus détaillés sur divers sujets pour le quotidien scolaire. Que ce soit l'IA, les méthodes numériques, les idées pédagogiques, la santé des enseignants et bien plus encore ! Développez-vous et développez votre enseignement de manière pratique et à votre propre rythme. De chaque formation en ligne, vous emportez des concepts concrets et des idées prêtes à l'emploi pour votre enseignement et votre quotidien professionnel."
        }
      }
    }
  }
}
